import { writable} from 'svelte/store';


export const charts = writable ([]);
export const updateTags = writable(false);
export const calledSave = writable(false);